import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { getDefaultFontSize } from 'hooks/useGetTypographyFonts';
import React from 'react';

export const UiContext = React.createContext({
  spacings: defaultSpacingPresets,
  getFontSize: getDefaultFontSize,
});
